import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const ProgressModel = types.model({
  done: types.integer,
  total: types.integer,
});

export interface ProgressInstance extends Instance<typeof ProgressModel> {}
export type ProgressSnapshot = SnapshotIn<typeof ProgressModel>;
